import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import { useTranslation, registerTranslations } from '@/hooks/useTranslation';
import Seo from '@/components/common/Seo';
import ContactForm from '@/components/common/ContactForm';
import HeroSection from './HeroSection';
import ContentSection from './ContentSection';
import translations from './translations';

// Registrieren der seitenspezifischen Übersetzungen
registerTranslations('aboutPage', translations);

const AboutPage = () => {
  const { t } = useTranslation();

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Seo 
        title="Über uns"
        description="Lernen Sie das Team hinter splusd-solutions kennen und erfahren Sie mehr über unsere Vision."
        canonical="/about"
      />
      <Layout>
        <main>
          <HeroSection />
          <ContentSection />
          <ContactForm />
        </main>
      </Layout>
    </>
  );
};

export default AboutPage; 